const PageGap = () => (
  <span className="tw-cursor-default" data-cy="pagination-gap">
    ...
  </span>
);

export default PageGap;
